import { api } from './api';

export const productApi = api.injectEndpoints({
  endpoints: (builder) => ({
    saveProduct: builder.mutation({
      query: (productData) => {
        return {
          url: 'saveProduct',
          method: 'POST',
          body: productData,
        };
      },
    }),

    deleteProducts: builder.mutation({
      query: ({
        order,
        orderBy,
        filter,
        filterKey,
        headerFilters,
        pageIndex,
        pageSize,
        userId,

        // additional criteria
        collections,
        tags,

        // hide inactivated products
        all,

        // for bulk edit
        selected,
        selectWhole,
      }) => {
        return {
          url: 'deleteProducts',
          method: 'POST',
          body: {
            order,
            orderBy,
            filter,
            filterKey,
            headerFilters,
            page: pageIndex,
            pageSize,
            userId,

            collections,
            tags,

            all,

            selected,
            selectWhole,
          },
        };
      },
    }),

    getProducts: builder.query({
      query: ({
        order,
        orderBy,
        filter,
        filterKey,
        headerFilters,
        pageIndex,
        pageSize,
        userId,

        // additional criteria
        collections,
        tags,

        // hide inactivated products
        all,

        dateRange,
      }) => {
        return {
          url: 'getProducts',
          method: 'POST',
          body: {
            order,
            orderBy,
            filter,
            filterKey,
            headerFilters,
            page: pageIndex,
            pageSize,
            userId,

            collections,
            tags,

            all,
            dateRange,
          },
        };
      },
    }),

    getProductsForSearching: builder.query({
      query: ({
        filter,
      }) => {
        return {
          url: 'getProductsForSearching',
          method: 'POST',
          body: {
            filter,
          },
        };
      },
    }),

    getProductCategories: builder.query<unknown, { userId?: number | string } | void>({
      query: ({ userId } = {}) => {
        return {
          url: userId
            ? `getProductCategories?userId=${userId}`
            : 'getProductCategories',
        };
      },
    }),

    getProductWithInventory: builder.mutation({
      query: ({ productId, addToOrderUserId }) => {
        return {
          url: `getProductWithInventory?productId=${productId}&addToOrderUserId=${addToOrderUserId}`,
        };
      },
    }),

    getProduct: builder.mutation({
      query: ({
        order,
        orderBy,
        filter,
        pageSize,
        headerFilters,
        productIndex,
        productId,
        ...rest
      }) => {
        return {
          url: 'getProduct',
          method: 'POST',
          body: {
            order,
            orderBy,
            filter,
            pageSize,
            headerFilters,
            productIndex,
            productId,
            ...rest,
          },
        };
      },
    }),

    uploadProducts: builder.mutation({
      query: ({
        productId,
        order,
        orderBy,
        filter,
        pageIndex,
        pageSize,
        products,
        all,
      }) => {
        return {
          url: 'uploadProducts',
          method: 'POST',
          body: {
            productId,
            order,
            orderBy,
            filter,
            pageIndex,
            pageSize,
            products,
            all,
          },
        };
      },
    }),

    // addon: product-bulk-edit
    bulkEditProducts: builder.mutation({
      query: ({
        order,
        orderBy,
        filter,
        filterKey,
        headerFilters,
        pageIndex,
        pageSize,
        userId,

        // additional criteria
        collections,
        tags,

        // hide inactivated products
        all,

        // for bulk edit
        selected,
        selectWhole,
        diffs,
      }) => {
        return {
          url: 'bulkEditProducts',
          method: 'POST',
          body: {
            order,
            orderBy,
            filter,
            filterKey,
            headerFilters,
            page: pageIndex,
            pageSize,
            userId,

            collections,
            tags,

            all,

            selected,
            selectWhole,
            diffs,
          },
        };
      },
    }),

    patchProductFeatured: builder.mutation({
      query: ({ productId, featured }) => ({
        url: 'patchProductFeatured',
        method: 'POST',
        body: { productId, featured },
      }),
    }),

  }),
});

export const {
  useGetProductWithInventoryMutation,
  useGetProductMutation,
  useSaveProductMutation,
  // useDeleteProductMutation,
  useDeleteProductsMutation,
  useGetProductsQuery,
  useGetProductsForSearchingQuery,
  useGetProductCategoriesQuery,
  useUploadProductsMutation,
  useBulkEditProductsMutation,
  usePatchProductFeaturedMutation,
} = productApi;
